<div class="salesWaterfallContainer" *ngIf="data.graph.data[currentBUIndex].graph">
  <div class="waterfall-container">
    <echarts
      [options]="chartOptions"
      (chartInit)="onChartInit($event)"
      [autoResize]="false"
      class="chart-container"
    >
    </echarts>
    <div class="table-container">
    <div *ngFor="let item of data.graph.data[currentBUIndex].table[selectedSliderValue].columns; let index = index; trackBy: trackByIndex" class="table-row">
      <span class="table-row-title">{{data.graph.data[currentBUIndex].table[selectedSliderValue].colNames[index]}}</span> <span class="table-row-data" *ngFor="let singleData of item"> {{singleData}}</span>
    </div>
    </div>
  </div>
  <div class="slider-container">
    <echarts
      [options]="chartOptionsSlider"
      (chartInit)="onChartInitSlider($event)"
      [autoResize]="false"
      class="chart-container"
    >
    </echarts>
  </div>
</div>
<div class="no-data-container" *ngIf="!data.graph.data[currentBUIndex].graph">
  <img src="assets/icons/notFound.svg" />
  <div>
    There is no comparison for this selection, please swipe left or right
  </div>
</div>